import { useCallback } from "react";
import type { SceneObject } from "@mind-sands/shared";
import { recompileActiveSpace } from "../lib/recompileScene";
import { useSceneStore } from "../stores/sceneStore";

/** Scene object mutations with automatic space recompilation */
export function useSceneObjects() {
  const addObjectToStore = useSceneStore((s) => s.addObject);
  const removeObjectFromStore = useSceneStore((s) => s.removeObject);

  const addObject = useCallback(
    async (object: SceneObject) => {
      addObjectToStore(object);
      await recompileActiveSpace();
    },
    [addObjectToStore],
  );

  const removeObject = useCallback(
    async (id: string) => {
      removeObjectFromStore(id);
      await recompileActiveSpace();
    },
    [removeObjectFromStore],
  );

  return { addObject, removeObject };
}
